<template>
	<NoSsr />
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import useStore from 'webmd-cms-store/src/store';
import NoSsr from '../client-only';
import _pick from 'lodash/pick';
import _set from 'lodash/set';
import _has from 'lodash/has';

export default {
	name: 'SetRendered',
	props: {
		chronicId: {
			type: String,
			required: true,
		},
		data: {
			type: Object,
			required: true,
		},
		articleType: {
			type: String,
			required: true,
		},
		relatedLinksdata: {
			type: Object,
			required: false,
		},
		isImageCollection: {
			type: Boolean,
			required: false,
		},
		isSiteFronts: {
			type: Boolean,
			required: false,
		},
	},
	components:{
		NoSsr
	},
	created() {
		this.store = useStore(this.$pinia);
		const chronickey = this.store.cms.getModules('articleModule')
			? 'articleModule' : this.chronicId;
		const articleDataKey = `${this.articleType}`;
		const articleTitleKey = `${this.articleType}.title`;
		const isInteractive = this.store.cms.isInteractivePage;
		let headerImagePathKey = '';
		let relatedLinksKey = '';
		let headerImageAltKey = '';

		if (this.isImageCollection) relatedLinksKey = `${this.articleType}.related_links_text.p.a`;

		if (isInteractive || this.isSiteFronts) {
			headerImagePathKey = _has(this.data, `${this.articleType}.media_asset.path`)
				? `${this.articleType}.media_asset.path` : '';
			headerImageAltKey = _has(this.data, `${this.articleType}.media_asset.wbmd_c_alt_tag`)
				? `${this.articleType}.media_asset.wbmd_c_alt_tag` : '';
		}

		/*
		 *When publication display is image collection then only take the related_links_text
		 *data into initial store otherwise Keep the regular data
		 */
		const data1 = _pick(this.data, ['module_settings.metadata_section.i_chronicle_id',
			'module_settings.metadata_section.wbmd_publ.wbmd_publ_name',
			'module_settings.metadata_section.wbmd_archive_bool',
			'module_settings.metadata_section.wbmd_c_channel_id.wbmd_disp_nm',
			'module_settings.metadata_section.wbmd_authr_prim_group.wbmd_authr_prim',
			'module_settings.metadata_section.wbmd_c_sec_authr_group.wbmd_c_sec_authr',
			'module_settings.metadata_section.wbmd_bus_ref.wbmd_disp_nm',
			'module_settings.metadata_section.wbmd_cpyrt.wbmd_copyright.wbmd_copyright_statement',
			'module_settings.metadata_section.wbmd_c_sec_med_revr',
			'module_settings.metadata_section.wbmd_prim_med_revr',
			'module_settings.metadata_section.wbmd_prim_revw_dt',
			'module_settings.metadata_section.wbmd_orig_pub_dt',
			'module_settings.metadata_section.wbmd_first_live_dt',
			'module_settings.metadata_section.wbmd_c_prim_top_id.wbmd_disp_nm',
			'module_settings.metadata_section.wbmd_c_sec_med_revw_dt',
			'module_settings.metadata_section.wbmd_publ.wbmd_publ_bus_entity.wbmd_bus_logo.path',
			'module_settings.metadata_section.wbmd_suppress_infinite',
			'module_settings.metadata_section.wbmd_disclmr',
			'module_settings.metadata_section.wbmd_secnd_category_group',
			articleDataKey,
			articleTitleKey,
			relatedLinksKey,
			headerImagePathKey,
			headerImageAltKey,
		]);
		if (this.isImageCollection) {
			_set(data1, relatedLinksKey, this.relatedLinksdata);
		}
		this.store.cms.UPDATE_STATE({ key: chronickey, value: data1 });
	},
};

</script>
<style scoped>
</style>
